const containerCls = "_n29c14r1iqg";
const scaleContainerCls = "_n29s10b1tjh";
const fontSizeContainerCls = "_n29f1j58tue";

export { containerCls, fontSizeContainerCls, scaleContainerCls };
import "./Input.style.linaria.module.css";
//# sourceMappingURL=Input.style.js.map
